import * as React from 'react'
import { Clock } from 'react-feather'

import { Strong, Text } from 'main/ui'
import { formatTime } from 'main/util/time'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'

import Bullet from '../common/Bullet'
import { i18nKeyPrefix } from '../i18n'

const PRE = `${i18nKeyPrefix}-BASICS-HOURS`

interface IProps {
  hoursEnd: string
  hoursStart: string
}

export default function Hours(props: IProps) {
  const { hoursStart, hoursEnd } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <Bullet icon={<Clock />}>
      <Strong>{t(`${PRE}-TEXT`)}</Strong>
      <Text muted>
        {formatTime(hoursStart)} &mdash; {formatTime(hoursEnd)}
      </Text>
    </Bullet>
  )
}
